import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";

import { Location } from "@angular/common";
import { GetSessionStore } from "./services/comment";
import api from "./api";
// import { rootRoute } from "_@angular_router@5.1.3@@angular/router/src/router_module";
/**
 *  路由守卫
 *  处理登录
 * @export
 * @class CheckRouteService
 * @implements {CanActivate}
 */
export class LoginService implements CanActivate {
  canActivate() {
    let loginSotre = JSON.parse(GetSessionStore("successLoginInfo"));
    if (loginSotre) {
      return true;
    } else {
      window.location.href = "/";
      return false;
    }
    // 这里判断登录状态, 返回 true 或 false
  }
}
/**
 *  路由守卫
 * @export
 * @class CheckRouteService
 * @implements {CanActivate}
 */
export class CheckRouteService implements CanActivate {
  canActivate() {
    let loginSotre = JSON.parse(GetSessionStore("successLoginInfo"));
    if (loginSotre) {
      let localUrl = window.location.href;
      let routeSys = localUrl.split("/").pop();
      let routeList = loginSotre.ssoSystems;
      routeList.map(item => {
        if (item.systemCode.toUpperCase() === routeSys.toUpperCase()) {
          let certificate = JSON.parse(GetSessionStore("successLoginInfo"))
            .certificate;
          let _url = `${api.ssoLink}${item.systemCode}/${certificate}`;
          window.location.href = _url;
        }
      });
      return true;
    } else {
      window.location.href = "/";
      return false;
    }
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/PermissionGuard.ts